import {useEffect, useState} from "react";
import {TextButton, Button, FlexBox, Modal, Title, Loader, MultiSelect} from "components";
import {useLazyGetPackagingManagerGroupsQuery, useUpdateProjectFoldersMutation} from "services/api/api.slice";
import { useDispatch } from "hooks/redux";
import { setNotification } from "services";
import Input from "../../components/forms/Input/Input";
import {ProjectFolderProps, ProjectFolderResponse, ProjectFoldersUpdateRequest, ProjectGroupProps} from "../../interfaces/PackagingManager";
import { v4 as uuid } from 'uuid';



export interface CreatePackagingManagerFolderModalModalProps {
  onClose: Function;
  onComplete: Function;
  folders: ProjectFolderResponse[];
  projectInstanceId: string;
}

const CreatePackagingManagerFolderModal = ({onClose, onComplete, folders, projectInstanceId}: CreatePackagingManagerFolderModalModalProps) => {
  const foldersForRequest: Array<ProjectFolderProps> = [];
  for (let folderIndex = 0; folderIndex < folders.length; folderIndex++) {
    const folderToMap = folders[folderIndex];
    const folderForRequest: ProjectFolderProps = {
      id: folderToMap.id,
      isActive: folderToMap.isActive,
      name: folderToMap.name,
    };
    foldersForRequest.push(folderForRequest);
  }
  
  const blankFolder = {
    id: uuid(),
    name: "",
    isActive: true
  }
  const dispatch = useDispatch();
  
  const [newFolder, _newFolder] = useState<ProjectFolderProps>(blankFolder);
  
  const [isLoading, _isLoading] = useState<boolean>(false);
  
  const handleClose = () => {
    onClose();
  };
  
  const [updateFolders, {isLoading: updateFoldersLoading, isSuccess}] = useUpdateProjectFoldersMutation();
  
  const handleFolderNameChange = (e: any) => {
    _newFolder((prevState) => {
      return {
        id: prevState.id,
        name: e.target.value,
        isActive: prevState.isActive      };
    });
  }
  
  const handleCreateFolder = () => {
    if (foldersForRequest.length === folders.length) {
      foldersForRequest.push(newFolder);
      _isLoading(true)
      const updateFoldersRequest: ProjectFoldersUpdateRequest = {
        projectInstanceId: projectInstanceId,
        folders: foldersForRequest
      }
      updateFolders(updateFoldersRequest)
      .unwrap()
      .then(() => {
        dispatch(
          setNotification({
            type: "success",
            message: "Folder created successfully",
          })
        );
      })
      .catch((error: unknown) => {
        dispatch(
          setNotification({
            type: "error",
            message: "Could not create folder",
          })
        );
        console.error(error);
      })
      .finally(() => {
        _isLoading(false);
      })
    }
  };
  
  useEffect(() => {
    if (isSuccess) {
      onComplete();
    }
  }, [isSuccess]);
  
  
  return (
    <Modal testId="new-project-folder-modal" open onClose={handleClose}>
      
      {isLoading ? (
        <Loader containerHeight="10rem" active />
      ) : (
        <FlexBox minWidth="100%">
          <Title size="large" bold pd="0 0 2rem">
            Add new folder
          </Title>
          
          <FlexBox pd="0 0 1.5rem">
            <Input
              data-testid="folder-name"
              name="newFolderName"
              value={newFolder.name}
              onChange={handleFolderNameChange}
              label="Folder name"
              maxWidth="60ch"
            />
          </FlexBox>
          
          <FlexBox row gap="1.5rem" align="center" justify="flex-start">
            <Button
              use="primary"
              data-testid="submit-button"
              onClick={handleCreateFolder}
              disabled={!(newFolder.name.trim().length > 0)}
            >
              Add folder
            </Button>
            <TextButton data-testid="cancel-button" onClick={handleClose}>
              Cancel
            </TextButton>
          </FlexBox>
        </FlexBox>
      )}
      
      
    </Modal>
  );
};

export default CreatePackagingManagerFolderModal;
